import {BasicAddressContent} from 'components/Identity';

export const BasicAddress = () => <BasicAddressContent />;
